module.exports = __webpack_public_path__ + "media/new_images/google-play-3b5d582c.svg";